var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"my_contents"}},[_c('div',{staticClass:"header"},[_c('Header')],1),_c('div',{attrs:{"id":"game_content"}},[_c('Contents')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }